export default __webpack_public_path__ + "static/media/slstmtrainloss.46c9177c.png";